export function getIsServer() {
  return typeof window === 'undefined'
}

export const sanitizeName = (name: string) => {
  return name.replace(/[‘’]/g, "'")
}

/**
 * Returns a string value to set a data-testid attribute on FieldCaption components based on its parent data-testid.
 * @param parentTestId - the data-testid value of the caption parent field.
 * @param isInvalid - adds a `-error` or `-caption` suffix to the parent data-testid.
 * @returns string
 * @example - "firstName-error", "firstName-caption"
 */
export function getFieldCaptionTestId(
  parentTestId: string | undefined,
  isInvalid: boolean | undefined
) {
  if (!parentTestId) return undefined
  return `${parentTestId}-${isInvalid ? 'error' : 'caption'}`
}

// Convert cents to dollars and return as a number with up to 2 decimal points.
export function convertCentsToFloat(amount: number) {
  return parseFloat((amount / 100).toFixed(2))
}
